import React from "react";
import './Body19.css';
import {Link} from "react-router-dom"
import picture310 from './source/picture310.png'
import picture311 from './source/picture311.png'
import picture312 from './source/picture312.png'
import picture313 from './source/picture313.png'
import picture314 from './source/picture314.png'
import picture315 from './source/picture315.png'




function Body19() {

  return (
    <div className="body19">
      <div className="body19-box1">
        <div className="body19-box2">
          <div className="body19-box3">Kudlovice</div>
          <div className="body19-box5"><div className="body19-box4"></div></div>
          <div className="body19-box6">
          <img className="body19-box6-picture2" src={picture311} alt="picture1"/>
          <img className="body19-box6-picture2" src={picture312} alt="picture1"/>
          <img className="body19-box6-picture2" src={picture315} alt="picture1"/>
          <img className="body19-box6-picture" src={picture310} alt="picture1"/>
          <img className="body19-box6-picture" src={picture313} alt="picture1"/>
          <img className="body19-box6-picture" src={picture314} alt="picture1"/>
          </div>
          <div className="body19-box8"><div className="body19-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body19;
